export const setBuyerDocumentTypes = (data) => ({
    type: 'BUYER_SET_DOCUMENT_TYPES',
    data,
});
